import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import MarkdownText from "../MarkdownText";

export type Props = {
	text: string;
};

const StreamedMessage = ({ text }: Props) => {
	const theme = useAppTheme();
	return (
		<Box paddingVertical={8} paddingRight={16}>
			<MarkdownText
				text={text}
				variant="explanation"
				style={{ color: theme.colors.onSurfaceVariant }}
			/>
		</Box>
	);
};

export default StreamedMessage;
